<template>
<div class="studySelector">
  <div class="label">{{selectorTitle}}</div>
  <div class="selectorWrapper">
    <b-dropdown :disabled="disable" size="lg" class="studyButton" variant="outline-light" :text="dropdownTitle">
      <b-dropdown-item v-for="(timeOption,idx) in timeFilterDef.options" :key="idx" @click="onTimeOptionSelected(timeOption)">{{timeOption.title}}</b-dropdown-item>
    </b-dropdown>
  </div>
</div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";

  export default {
  name: 'TimeSelector',

  props: {
    trend: Boolean,
    disable: Boolean
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters(['studies', 'getFilterDef', 'getSelectedFilterOptions', 'selectionTimeFilterDef', 'trendTimeFilterDef']),
    ...mapState(['activeStudy']),


    filterName() {
      return this.trend ? 'vz' : 'z'
    },

    timeFilterDef() {
      return this.trend ? this.trendTimeFilterDef : this.selectionTimeFilterDef;
    },

    dropdownTitle() {
      const options = this.getSelectedFilterOptions(this.filterName)
//      console.log("Options" + options)
      return (options && options.length==1) ? options[0].title : "???"
    },

    selectorTitle() {
      return this.trend ? this.$t("TREND_TIME_INTERVAL") : this.$t("TIME_INTERVAL");
    },

    timeIntervals() {
      return this.trend ? this.trendIntervals : this.selectionIntervals;
    }

  },

  methods: {
    onTimeOptionSelected(timeOption) {
//      console.log("Selection: " + timeOption.extName)
      this.$store.commit('setFilterOptions', { filterDef: this.timeFilterDef, filterOptions: [ timeOption ] } )
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  div.studySelector {
    padding-bottom: 1em;
  }

  .label {
    color: white;
    font-size: 1.5em;
    text-align: center;
  }

  .selectorWrapper {
    text-align: center;
  }

  /*.dropdown-toggle::after {*/
  /*  position: relative;*/
  /*}*/

  /*!* Align Bootstrap default Dropdown icon closer to vertical center of collapsed icon. *!*/
  /*.dropdown-toggle::after {*/
  /*  vertical-align: 0.15em;*/
  /*}*/

  /*!* Make Dropdown icon point right when collapsed, with Browser default vertical alignment. *!*/
  /*.collapsed.dropdown-toggle::after {*/
  /*  border-top: 0.3em solid transparent;*/
  /*  border-left: 0.3em solid;*/
  /*  border-bottom: 0.3em solid transparent;*/
  /*  border-right: 0;*/
  /*  vertical-align: unset;*/
  /*}*/

  .studyButton button  {
    /*font-size: 1.5em;*/
    /*background-color: transparent;*/
    padding-top: 0;
    padding-bottom: 0;
  }


</style>
